export default "__VITE_ASSET__9suIUDqZ__"